<meta name="viewport" content="width=device-width, initial-scale=1"></meta>

<template>
  <div class="heroBlock">
    <v-carousel hide-delimiters cycle>
      <v-carousel-item
        v-for="(item, i) in items"
        :key="i"
        :src="item.src"
        reverse-transition="fade-transition"
        transition="fade-transition"
      >
        <v-row
          class="title fill-height hidden-xs-only"
          justify="center"
          align="center"
        >
          <div>{{ item.title || item.button }}</div>
        </v-row>
      </v-carousel-item>
    </v-carousel>
  </div>
</template>

<script>
export default {
  name: "Hero",
  data() {
    return {
      items: [
        {
          src: require("../../assets/fotoMaletin.png"),
          title: "Watch realtime WoT devices!",
        },
        {
          src: require("../../assets/fotoMaletin2.png"),
          button: "Live On YouTube",
        },
        {
          src: require("../../assets/fotoMaletin3.png"),
          title: "Watch the status of some of the devices in realtime.",
        },
      ],
    };
  },
};
</script>